import { call, put, takeLatest } from 'redux-saga/effects';
import {
  BUSCAR_RESUMO_CONCILIACAO,
  BUSCAR_RESUMO_CONCILIACAO_PENDING,
  BUSCAR_RESUMO_CONCILIACAO_SUCCESS,
  BUSCAR_RESUMO_CONCILIACAO_FAILURE,
} from '../actionTypes';
import { conciliacaoBancariaService } from '../service';

function* sagaBuscarResumoConciliacao(action) {
  try {
    yield put({ type: BUSCAR_RESUMO_CONCILIACAO_PENDING });

    const { contaBancoId } = action;

    const response = yield call(
      conciliacaoBancariaService.buscarResumoConciliacao,
      contaBancoId
    );

    // A API pode retornar os dados em response.data ou diretamente em response
    const responseData = response.data || response;

    yield put({
      type: BUSCAR_RESUMO_CONCILIACAO_SUCCESS,
      response: responseData
    });

  } catch (error) {
    yield put({
      type: BUSCAR_RESUMO_CONCILIACAO_FAILURE,
      error: error.message || 'Erro ao buscar resumo da conciliação'
    });
  }
}

export default function* watchBuscarResumoConciliacao() {
  yield takeLatest(BUSCAR_RESUMO_CONCILIACAO, sagaBuscarResumoConciliacao);
}
